import styled from 'styled-components'

export const PageCard = styled.section`
  margin-top: 32px;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);

  @media (max-width: 700px) {
    padding: 16px;
  }
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;

  h2 {
    margin: 0;
    color: #1f344d;
    font-size: 26px;
    font-weight: 800;
  }

  p {
    margin: 6px 0 0;
    color: #60758b;
  }
`

export const SearchForm = styled.form`
  display: flex;
  width: 100%;
  min-height: 48px;

  input {
    flex: 1;
    min-width: 0;
    padding: 0 14px;
    border: 1px solid #d4e0ec;
    border-radius: 14px 0 0 14px;
    color: #1f344d;
    font: inherit;
  }

  button {
    padding: 0 18px;
    border: 0;
    border-radius: 0 14px 14px 0;
    background: #2d749c;
    color: #ffffff;
    cursor: pointer;
  }
`

export const Filters = styled.div`
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 22px;
`

export const FilterGroup = styled.div`
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  max-width: 100%;
  padding: 4px;
  border-radius: 12px;
  background: #eff5fb;

  @media (max-width: 800px) {
    flex-wrap: wrap;
  }
`

export const FilterButton = styled.button<{ selected: boolean }>`
  padding: 10px 14px;
  border: 0;
  border-radius: 9px;
  background: ${(props) => (props.selected ? '#ffffff' : 'transparent')};
  box-shadow: ${(props) => (props.selected ? '0 2px 8px rgba(31, 52, 77, 0.1)' : 'none')};
  color: ${(props) => (props.selected ? '#1f344d' : '#60758b')};
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
`

export const ProcessFilter = styled.label`
  display: grid;
  gap: 5px;
  flex: 0 1 220px;
  min-width: 180px;
  color: #536b84;
  font-size: 13px;
  font-weight: 700;

  select {
    box-sizing: border-box;
    width: 100%;
    min-height: 48px;
    padding: 0 12px;
    border: 1px solid #d4e0ec;
    border-radius: 14px;
    background: #ffffff;
    color: #1f344d;
    font: inherit;
  }

  @media (max-width: 800px) {
    flex-basis: 100%;
  }
`

export const SearchControl = styled.div`
  display: grid;
  gap: 5px;
  flex: 0 1 320px;
  min-width: 240px;
  color: #536b84;
  font-size: 13px;
  font-weight: 700;

  > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  > div button {
    padding: 0;
    border: 0;
    background: none;
    color: #2d749c;
    font: inherit;
    cursor: pointer;
  }

  @media (max-width: 800px) {
    flex-basis: 100%;
  }
`

export const TableFrame = styled.div`
  overflow: hidden;
  border: 1px solid #e5edf4;
  border-radius: 14px;
`

export const UsersTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    padding: 17px 12px;
    background: #eff5fb;
    color: #163247;
    font-size: 12px;
    text-align: left;
  }

  td {
    padding: 15px 12px;
    border-top: 1px solid #e5edf4;
    color: #536b84;
    font-size: 14px;
    overflow-wrap: anywhere;
  }

  tbody tr:hover {
    background: #f8fbfe;
  }

  th:nth-child(1) {
    width: 16%;
  }
  th:nth-child(2) {
    width: 10%;
  }
  th:nth-child(3) {
    width: 12%;
  }
  th:nth-child(4) {
    width: 18%;
  }
  th:nth-child(5) {
    width: 14%;
  }
  th:nth-child(6) {
    width: 9%;
  }
  th:nth-child(7) {
    width: 10%;
  }
  th:nth-child(8) {
    width: 11%;
  }

  @media (max-width: 1100px) {
    thead {
      display: none;
    }
    tbody {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    }
    tr {
      display: grid;
      padding: 16px;
      border-top: 1px solid #e5edf4;
    }
    td {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      padding: 6px 0;
      border: 0;
    }
    td::before {
      content: attr(data-label);
      color: #163247;
      font-weight: 700;
    }
  }
`

export const Status = styled.span<{ positive: boolean }>`
  display: inline-block;
  padding: 5px 9px;
  border-radius: 999px;
  background: ${(props) => (props.positive ? '#e8f7ed' : '#eff3f7')};
  color: ${(props) => (props.positive ? '#247645' : '#64788c')};
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
`

export const RowActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  button {
    padding: 7px 10px;
    border: 1px solid #b6c2d6;
    border-radius: 9px;
    background: #ffffff;
    color: #2d749c;
    font-weight: 700;
    cursor: pointer;
  }
`

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  color: #60758b;
`
